import Permission from "types/Permission.enum";
import QueryStatus from "types/QueryStatus.enum";
import { useUser } from "services/users.service";

const useHasPermissions = (
  requiredPermissions: Permission[],
  oneOf = false
) => {
  const { data, status } = useUser();

  if (status !== QueryStatus.success) {
    return false;
  }

  const { permissions: userPermissions } = data;

  let hasRequiredPermissions: boolean = requiredPermissions.every(
    (permission) => userPermissions.includes(permission)
  );

  if (oneOf) {
    hasRequiredPermissions = requiredPermissions.some((permission) =>
      userPermissions.includes(permission)
    );
  }

  return hasRequiredPermissions;
};

export default useHasPermissions;
